type NavigatorWithUAData = Navigator & { userAgentData?: { platform?: string } };

export const isMac = (): boolean => {
    if (typeof navigator === 'undefined') {
        return false;
    }

    const platform =
        (navigator as NavigatorWithUAData).userAgentData?.platform || navigator.platform || '';

    return /mac/i.test(platform);
};
